import { useState, useEffect, useCallback } from 'react';

/**
 * Hook para atualizar o tempo de espera das senhas em tempo real
 * @param {Array} senhas - Array de senhas com campo emitida_em
 * @param {number} intervalo - Intervalo de atualização em milissegundos (padrão: 30000 = 30s)
 * @returns {Array} Array de senhas com tempo de espera atualizado
 */
const useRealtimeWaitTime = (senhas = [], intervalo = 30000) => {
  const [senhasComTempo, setSenhasComTempo] = useState([]);

  // Função para calcular o tempo de espera
  const calcularTempoEspera = useCallback((dataEmissao) => {
    if (!dataEmissao) return '0 min';
    
    const agora = new Date();
    const emissao = new Date(dataEmissao);
    const diferencaMs = agora - emissao;
    const diferencaMinutos = Math.floor(diferencaMs / (1000 * 60));
    
    if (diferencaMinutos < 60) {
      return `${diferencaMinutos} min`;
    } else {
      const horas = Math.floor(diferencaMinutos / 60);
      const minutosRestantes = diferencaMinutos % 60;
      return `${horas}h ${minutosRestantes}min`;
    }
  }, []);

  // Função para atualizar os tempos de espera
  const atualizarTemposEspera = useCallback(() => {
    if (!senhas || senhas.length === 0) {
      setSenhasComTempo([]);
      return;
    }

    const senhasAtualizadas = senhas.map(senha => ({
      ...senha,
      tempEspera: calcularTempoEspera(senha.emitida_em)
    }));

    setSenhasComTempo(senhasAtualizadas);
  }, [senhas, calcularTempoEspera]);

  // Efeito para atualização inicial e configuração do intervalo
  useEffect(() => {
    // Atualização inicial
    atualizarTemposEspera();

    // Configurar intervalo para atualização periódica
    const intervalId = setInterval(atualizarTemposEspera, intervalo);

    // Limpeza do intervalo
    return () => {
      clearInterval(intervalId);
    };
  }, [atualizarTemposEspera, intervalo]);

  // Efeito para reagir a mudanças no array de senhas
  useEffect(() => {
    atualizarTemposEspera();
  }, [senhas, atualizarTemposEspera]);

  return senhasComTempo;
};

export default useRealtimeWaitTime; 